module.exports = __webpack_public_path__ + "img/vegano.8c1ec8c2.svg";